module.exports = __webpack_public_path__ + "img/year.c7f788d9.svg";